module.exports = __webpack_public_path__ + "static/media/fb.06f1a154.jpg";